module.exports = __webpack_public_path__ + "img/8.95ff3b09.jpg";